import { Injectable } from '@angular/core';

import { ModalRef } from '@app/modules/core-modal/models/modal-ref';
import { I18nService } from '@app/shared/services/i18n/i18n.service';
import { lazyInject } from '@app/shared/decorators';

import { ModalService } from '../modal.service';
import { AlertParams, ConfirmParams } from '../../modal.types';
import { AlertComponent } from '../../components';
import { ConfirmComponent } from '../../components/root-modal-components/confirm/confirm.component';
import { ModalCommandActions } from '../../modal.enums';

@Injectable()
export class RootModalService extends ModalService {
  @lazyInject(I18nService) public i18nService: I18nService;

  public alert(params: AlertParams): ModalRef {
    return this.open(AlertComponent, { data: params });
  }

  public confirm(params: ConfirmParams): ModalRef {
    return this.open(ConfirmComponent, { data: params });
  }

  public closeAllModals(isAutoLogout?: boolean): void {
    const payload = isAutoLogout ? { isAutoLogout } : undefined;
    this.coreModalService.closeAllModals({
      action: ModalCommandActions.CANCEL,
      payload,
    });
  }
}
